/**
 * A quién se espera en la mesa. En 7 Wonders todos eligen a la vez: «te toca» significa que la
 * ronda (o la elección de lado) espera tu decisión; las acciones especiales van de una en una.
 */
import type { PlayerView } from '@sw/engine';

export type SeatStatus = 'yourTurn' | 'choosing' | 'ready' | 'frozen' | 'acting' | null;

export function seatStatus(view: PlayerView, seat: number): SeatStatus {
  const p = view.players[seat];
  if (!p) return null;
  if (p.status === 'frozen') return 'frozen';
  const d = view.decision;
  if (d.kind === 'gameOver') return null;
  if (d.kind === 'special') return d.seat === seat ? 'acting' : null;
  if (p.ready) return 'ready';
  return view.me?.seat === seat ? 'yourTurn' : 'choosing';
}

/**
 * ¿Acaba de llegarme una mano nueva por elegir? Sin vista previa (recarga o reconexión) no:
 * el aviso es para el momento en que empieza la ronda, no para cuando vuelves a ella.
 */
export function isNewHandForMe(prev: PlayerView | null | undefined, next: PlayerView): boolean {
  if (!prev || !next.me) return false;
  if (next.decision.kind !== 'turn' || next.decisionId === prev.decisionId) return false;
  if (next.players[next.me.seat]?.status !== 'active') return false;
  return next.me.selection === null && next.me.hand.length > 0;
}
